'use client';

import { useContext } from 'react';
import { LanguageContext } from '@/components/ui/LanguageToggle';
import { getTranslation } from '@/data/translations';

export function useTranslation() {
  const { language } = useContext(LanguageContext);
  
  // 返回一个t函数，用于获取当前语言的翻译
  const t = (key: string): string => {
    return getTranslation(key, language);
  };
  
  return {
    t,
    language
  };
} 